import { useCallback, useRef } from 'react';

/** Anti-spam fields every lead mutation sends (see LeadAntiSpamInput on tzilla-be). */
export type LeadGuardFields = { honeypot?: string; elapsedMs?: number };

/**
 * Bot trap for a lead form: a hidden field people never see or fill, plus how long the form
 * was open before submit. Render `field` inside the <form> and spread `read()` into the data
 * passed to databaseService. The backend files anything suspicious under Spam without emailing.
 */
export function useLeadGuard() {
  const openedAt = useRef<number>(Date.now());
  const trap = useRef<HTMLInputElement>(null);

  const read = useCallback(
    (): LeadGuardFields => ({
      honeypot: trap.current?.value || undefined,
      elapsedMs: Date.now() - openedAt.current,
    }),
    [],
  );

  /** Call when a modal opens, so time spent with it closed doesn't count. */
  const reset = useCallback(() => {
    openedAt.current = Date.now();
  }, []);

  const field = (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-10000px', width: 1, height: 1, overflow: 'hidden' }}>
      <label>
        Website
        <input ref={trap} type="text" name="company_website" tabIndex={-1} autoComplete="off" defaultValue="" />
      </label>
    </div>
  );

  return { field, read, reset };
}
